module.exports = __webpack_public_path__ + "img/87652.91a6db9c.png";